import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Quote } from '../types/quote';
import { post } from '../lib/api';

export const useQuotesCreate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (quote: Omit<Quote, 'id'>) => {
      return post<Quote>('/quotes', quote);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
    },
  });
}; 